import { jsxs as e, jsx as r } from "react/jsx-runtime";
import o from "@mui/joy/Stack";
import { HeaderCellElement as l, DayCellElement as a } from "./components/index.js";
import t from "./hooks/useCalendarCells.js";
const d = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Нд"], i = ({ date: i2, headerCell: n = l, dayCell: s = a, extraCellProps: m, hideHeaderCells: p = false, useCalendarHook: x = t }) => {
  const c = x(i2);
  return e(o, { sx: { gap: 0, overflow: "hidden", overflowY: "auto" }, children: [!p && r(o, { sx: { flexDirection: "row", mb: "-1px" }, children: d.map((e2) => r(n, { dayOfWeek: e2 }, e2)) }), r(o, { direction: "row", flexWrap: "wrap", children: c.map(({ index: e2, ...o2 }) => r(s, { ...o2, extraCellProps: m }, e2)) })] });
};
export {
  i as Calendar,
  i as default
};
//# sourceMappingURL=index.js.map
